import  { useMemo } from "react";
import { Modal, Space, Tag, Radio, Checkbox } from "antd";
import { money } from "../../utils/money";

export type Modifier = { id:number; name:string; price_delta:number|string };
export type ModifierGroup = {
  id:number; name:string; required?:boolean; min_select?:number|null; max_select?:number|null; modifiers?:Modifier[];
};

export default function ModifierModal({
  open, productName, groups, selections, setSelections, onOk, onCancel,
}: {
  open: boolean;
  productName?: string;
  groups: ModifierGroup[];
  selections: Record<number, number[]>;
  note?: string;
  setNote?: (v:string)=>void;
  setSelections: (updater: (prev:Record<number,number[]>)=>Record<number,number[]>) => void;
  onOk: ()=>void;
  onCancel: ()=>void;
}) {
  // validacija kao u tvom ranijem kodu
  const isValid = useMemo(()=>{
    for (const g of groups) {
      const picked = selections[g.id] || [];
      const min = (g.required ? Math.max(1, g.min_select || 0) : g.min_select || 0) || 0;
      const max = g.max_select || 99;
      if (picked.length < min) return false;
      if (picked.length > max) return false;
    }
    return true;
  }, [groups, selections]);

  return (
    <Modal
      title={productName ? `Modifikatori: ${productName}` : "Modifikatori"}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText="Dodaj"
      okButtonProps={{ disabled: !isValid }}
      width={760}
    >
      {groups.length ? (
        <Space direction="vertical" size="large" style={{ width:"100%" }}>
          {groups.map((g)=>{
            const picked = new Set(selections[g.id] || []);
            const max = g.max_select || 99;
            const toggle = (id:number, checked:boolean) => {
              setSelections((prev)=>{
                const cur = new Set(prev[g.id] || []);
                if (checked) { if (cur.size >= max) return prev; cur.add(id); }
                else cur.delete(id);
                return { ...prev, [g.id]: Array.from(cur) };
              });
            };
            return (
              <div key={g.id} style={{ border:"1px solid #f0f0f0", borderRadius:8, padding:12 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
                  <div style={{ fontWeight:600 }}>
                    {g.name}{" "}
                    {g.required ? <Tag color="red" style={{ marginLeft:8 }}>obavezno</Tag>
                                : <Tag color="blue" style={{ marginLeft:8 }}>opcionalno</Tag>}
                  </div>
                  <div style={{ color:"#999", fontSize:12 }}>
                    {g.min_select ? `min ${g.min_select}` : ""} {g.max_select ? ` / max ${g.max_select}` : ""}
                  </div>
                </div>

                {(g.max_select || 0) === 1 ? (
                  <Radio.Group
                    value={Array.from(picked)[0]}
                    onChange={(e)=> setSelections(prev => ({ ...prev, [g.id]: e.target.value ? [e.target.value] : [] }))}
                    style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(220px, 1fr))", gap:8 }}
                  >
                    {g.modifiers?.map((m)=>(
                      <Radio key={m.id} value={m.id}>
                        {m.name}{Number(m.price_delta) ? ` (+${money(m.price_delta)} KM)` : ""}
                      </Radio>
                    ))}
                  </Radio.Group>
                ) : (
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(220px, 1fr))", gap:8 }}>
                    {g.modifiers?.map((m)=>(
                      <Checkbox key={m.id} checked={picked.has(m.id)} onChange={(e)=>toggle(m.id, e.target.checked)}>
                        {m.name}{Number(m.price_delta) ? ` (+${money(m.price_delta)} KM)` : ""}
                      </Checkbox>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
          
        </Space>
      ) : <div>Nema dostupnih modifikatora.</div>}
    </Modal>
  );
}
